// src/components/DesktopHeader.jsx
import React from 'react';
import useModal from '../hooks/useModal';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';
import Modal from './Modal';

export default function DesktopHeader() {
  // replace the two inline popup functions
  const login = useModal();
  const signup = useModal();

  return (
    <div id="__nuxt">
      <div id="__layout">
        <div>
          <div className="is-hidden-mobile" data-v-30663520="">
            <div className="desktop-header-placeholder" data-v-30663520="" />
            <div
              data-cy="desktop-header"
              className="desktop-header section inverse"
              data-v-30663520=""
            >
              <div
                className="container desktop-header-inner"
                data-v-30663520=""
              >
                <div className="header-left" data-v-30663520="">
                  <a
                    href="/"
                    aria-current="page"
                    className="nuxt-link-exact-active nuxt-link-active"
                    data-v-30663520=""
                  >
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c"
                      alt="ft"
                      className="logo"
                      data-v-30663520=""
                      width="83"
                      height="30"
                    />
                  </a>
                </div>

                <ul data-cy="desktop-nav" className="nav-bar" data-v-30663520="">
                  <li className="dropdown-new" data-cy="desktop-nav-item" data-v-30663520="">
                    <a
                      href="/"
                      id="dropdown-toggle-new"
                      className="menu-item nuxt-link-exact-active nuxt-link-active"
                      data-v-30663520=""
                    >
                      Home
                    </a>
                    <ul className="dropdown-menu-new" id="dropdown-menu-new" />
                  </li>

                  <li className="dropdown-new" data-cy="desktop-nav-item" data-v-30663520="">
                    <a
                      href="#"
                      id="dropdown-toggle-new"
                      className="menu-item"
                      data-v-30663520=""
                    >
                      Talent
                    </a>
                    <ul className="dropdown-menu-new" id="dropdown-menu-new">
                      <li><a href="/discovery">Discovery</a></li>
                      <li><a href="/portfolio">Portfolio</a></li>
                      <li><a href="/masterclass">MasterClass</a></li>
                      <li><a href="/awards">Awards</a></li>
                      <li><a href="/opportunities">Opportunities</a></li>
                      <li><a href="/projects">Projects</a></li>
                    </ul>
                  </li>

                  <li className="dropdown-new" data-cy="desktop-nav-item" data-v-30663520="">
                    <a
                      href="#"
                      id="dropdown-toggle-new"
                      className="menu-item"
                      data-v-30663520=""
                    >
                      Media
                    </a>
                    <ul className="dropdown-menu-new" id="dropdown-menu-new">
                      <li><a href="/updates">Updates</a></li>
                      <li><a href="/streaming">Streaming</a></li>
                      <li><a href="/spotlight">Spotlight</a></li>
                      <li><a href="/podcast">Podcast</a></li>
                      <li><a href="/sponsor">Blog</a></li>
                          {/*
                          <li>
                            <a href="/">Connect with us on</a>
                          </li>
                          */}

                          {/*
                          <li>
                            <a href="/">YouTube LinkedIn Instagram Facebook Tiktok</a>
                          </li>
                          */}
                    </ul>
                  </li>

                  <li className="dropdown-new" data-cy="desktop-nav-item" data-v-30663520="">
                    <a
                      href="#"
                      id="dropdown-toggle-new"
                      className="menu-item"
                      data-v-30663520=""
                    >
                      Agency
                    </a>
                    <ul className="dropdown-menu-new" id="dropdown-menu-new">
                      <li><a href="/advertising">Advertising & PR</a></li>
                      <li><a href="/marketing-package">Marketing Packages</a></li>
                      <li><a href="/celebrity-campaigns">Celebrity Campaigns</a></li>
                      <li><a href="/brand-ambassadors">Brand Ambassadors</a></li>
                      <li><a href="/digital-marketing">Digital Marketing</a></li>
                      <li><a href="/social-media-management">Social Media Management</a></li>
                      <li><a href="/content-production">Content Production</a></li>
                      <li><a href="/media-strategy">Media Strategy</a></li>
                      <li><a href="/product-launch">Product Launch</a></li>
                      <li><a href="/promotional-events">Promotional Events</a></li>
                      <li><a href="/event-staff">Event Staff</a></li>
                      <li><a href="/event-management">Event Management</a></li>
                      <li><a href="/training">Training</a></li>
                      <li><a href="/insights">Insights</a></li>
                    </ul>
                  </li>

                  <li className="dropdown-new" data-cy="desktop-nav-item" data-v-30663520="">
                    <a
                      href="#"
                      id="dropdown-toggle-new"
                      className="menu-item"
                      data-v-30663520=""
                    >
                      Community
                    </a>
                    <ul className="dropdown-menu-new" id="dropdown-menu-new">
                      <li><a href="/join-flourishtalents-club">FlourishTalents Club</a></li>
                      <li><a href="/member-portal">Membership Portal</a></li>
                      <li><a href="/community-outreach">Community Outreach</a></li>
                      <li><a href="/patrons-forum">Patrons' Forum</a></li>
                      <li><a href="/exclusive-offers">Exclusive Offers</a></li>
                      <li><a href="/merchandise">Merchandise</a></li>
                      <li><a href="/events">Events</a></li>
                      <li><a href="/vacancies">Vacancies</a></li>
                      <li><a href="/our-partners">Partners</a></li>
                          {/*
                          <li>
                            <a href="/">Connect with us on</a>
                          </li>
                          */}

                          {/*
                          <li>
                            <a href="/">LinkedIn Instagram Facebook Tiktok</a>
                          </li>
                          */}
                    </ul>
                  </li>
                </ul>

                <div className="header-right" data-v-30663520="">
                  {/* Log in button opens React Modal */}
                  <button
                    id="login-desktop-button"
                    className="button grey is-shadowless login-button header-right-item is-rounded login-desktop-button"
                    data-cy="desktop-header-login-button"
                    data-v-30663520=""
                    onClick={login.openModal}
                  >
                    <span>Log in</span>
                  </button>

                  {/* Sign up button opens React Modal */}
                  <button
                    id="signup-desktop-button"
                    className="button primary has-soft-shadow login-button header-right-item signup_btn is-rounded signup-desktop-button"
                    data-cy="register-button"
                    data-v-30663520=""
                    onClick={signup.openModal}
                  >
                    <span>Sign up</span>
                  </button>

                  {/* Additional menu unchanged */}
                  <div className="additional-menu header-right-item" data-v-30663520="">
                    <div
                      data-cy="desktop-additional-menu-dropdown"
                      className="dropdown dropdown-menu-animation is-bottom-left"
                      data-v-30663520=""
                    >
                      <div role="button" tabIndex="0" className="dropdown-trigger">
                        <div
                          aria-label="layout.buttons.additional_menu"
                          data-cy="desktop-additional-menu-opener"
                          className="additional-menu-trigger"
                          data-v-30663520=""
                        >
                          <div
                            role="button"
                            aria-label="layout.buttons.additional_menu_icon"
                            className="hamburger-menu"
                            data-v-235e3428=""
                            data-v-30663520=""
                          >
                            <span data-v-235e3428=""></span>
                            <span data-v-235e3428=""></span>
                            <span data-v-235e3428=""></span>
                            <span data-v-235e3428=""></span>
                          </div>
                        </div>
                      </div>
                      {/* The dropdown-content remains hidden by default */}
                      <div
                        aria-hidden="true"
                        className="dropdown-menu"
                        style={{ display: 'none' }}
                      >
                        <div
                          role="list"
                          className="dropdown-content"
                          style={{ maxHeight: 'calc(100vh - 5rem)', overflow: 'auto' }}
                        >
                          <div
                            aria-role="listitem"
                            has-link=""
                            data-cy="desktop-additional-menu-item"
                            className="additional-menu-item"
                            data-v-30663520=""
                          >
                            <a
                              href="/memberships/"
                              className="button primary is-rounded upgradeLink"
                              data-v-30663520=""
                            >
                              <span className="icon is-normal" style={{ fontSize: '24px' }} data-v-563d9226="" data-v-30663520="">
                                {/* SVG omitted for brevity */}
                              </span>
                              <span data-v-30663520="">Upgrade now</span>
                            </a>
                          </div>
                          <div
                            aria-role="listitem"
                            has-link=""
                            data-cy="desktop-additional-menu-item"
                            className="additional-menu-item"
                            data-v-30663520=""
                          >
                            <a
                              href="https://www.flourishtalents.com/blog/"
                              target="_blank"
                              rel="noopener"
                              data-v-30663520=""
                            >
                              <span className="icon is-normal" style={{ fontSize: '24px' }} data-v-563d9226="" data-v-30663520="">
                                {/* SVG omitted for brevity */}
                              </span>
                              <span data-v-30663520="">Blog</span>
                            </a>
                          </div>
                          {/* Language list hidden */}
{/*
<div id="" className="collapse-content" style={{ display: 'none' }}>
  <div className="languages">
    <a href="/en/" data-cy="language-item" className="language-item selected">
      English
    </a>
    <a href="/es/" data-cy="language-item" className="language-item">
      Español
    </a>
    <a href="/de/" data-cy="language-item" className="language-item">
      Deutsch
    </a>
    <a href="/ru/" data-cy="language-item" className="language-item">
      Русский
    </a>
    <a href="/fr/" data-cy="language-item" className="language-item">
      Français
    </a>
    <a href="/it/" data-cy="language-item" className="language-item">
      Italiano
    </a>
  </div>
</div>
*/}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* React‐controlled Modals instead of inline popups */}
        <Modal isOpen={login.isOpen} onClose={login.closeModal}>
          <LoginForm onSuccess={login.closeModal} />
        </Modal>
        <Modal isOpen={signup.isOpen} onClose={signup.closeModal}>
          <SignupForm onSuccess={signup.closeModal} />
        </Modal>
      </div>
    </div>
  );
}
